export class ErrorUnlockingWallet extends Error {
    constructor() {
        super('There was an error unlocking your wallet. Please be sure your wallet is unlocked and try again.');
        this.name = 'ErrorUnlockingWallet';
    }
}
//# sourceMappingURL=types.js.map